import { render } from "./PromotionBillPanel.vue?vue&type=template&id=b486c266&scoped=true"
import script from "./PromotionBillPanel.vue?vue&type=script&lang=js"
export * from "./PromotionBillPanel.vue?vue&type=script&lang=js"

import "./PromotionBillPanel.vue?vue&type=style&index=0&id=b486c266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b486c266"]])

export default __exports__